module.exports = __webpack_public_path__ + "media/src/assets/Images/Midinero-48e66897024b87fcf64fd4c0d9c8f712.svg";